<ng-container *ngIf="isFooterVisible">
  <div
    *ngIf="!hideFooterMenu"
    class="footer"
    [ngClass]="{ 'mt-0 pt-5 br-0 custom-top-footer-border': !!backgroundColor }"
    [ngStyle]="{ background: backgroundColor }"
  >
    <div class="container footer-container">
      <!-- <div *ngIf="!isLogedIn" class="d-block d-lg-none footer-language-switcher">
        <app-language-switcher></app-language-switcher>
      </div> -->
      <div class="row">
        <div class="col-12 col-lg-6 footer-info">
          <em class="icon-liteTopfan-logo"></em>
          <p>WHAT IS TOPFAN?</p>
          <p>
            By directly supporting the Creators and groups you love on TopFan,
            you are helping them reach financial sustainability to pursue their
            passions. As a valued supporter, you receive exclusive content, a
            personal relationship with Creators and other Fans, and the pride of
            being involved with the creative process that results in content that
            inspires you.
          </p>
          <div *ngIf="!whiteLabelConfig" class="d-flex align-items-center app-download-links gap-2">
            <a class="download-link-wrap" [href]="DOWNLOAD_LINKS.APP_STORE_LINK" rel="noopener noreferrer" [aria-label]="DOWNLOAD_LINKS.APP_STORE" [title]="DOWNLOAD_LINKS.APP_STORE">
              <img 
                appMobileOptimization
                [originalUrl]="DOWNLOAD_LINKS.APP_STORE_ICON"
                [src]="DOWNLOAD_LINKS.APP_STORE_ICON" 
                width="25"
                height="25"
                alt="App Store"
                loading="lazy"
                decoding="async">
              <div class="download-link-text">
                <p>{{DOWNLOAD_LINKS.DOWNLOAD_ON_THE}}</p>
                <p class="download-link-title">{{DOWNLOAD_LINKS.APP_STORE}}</p>
              </div>
            </a>
            <a class="download-link-wrap" [href]="DOWNLOAD_LINKS.GOOGLE_PLAY_LINK" rel="noopener noreferrer" [aria-label]="DOWNLOAD_LINKS.GOOGLE_PLAY" [title]="DOWNLOAD_LINKS.GOOGLE_PLAY">
              <img 
                appMobileOptimization
                [originalUrl]="DOWNLOAD_LINKS.GOOGLE_PLAY_ICON"
                [src]="DOWNLOAD_LINKS.GOOGLE_PLAY_ICON" 
                width="25"
                height="25"
                alt="App Store"
                loading="lazy"
                decoding="async">
              <div class="download-link-text">
                <p>{{DOWNLOAD_LINKS.GET_IT_ON}}</p>
                <p class="download-link-title">{{DOWNLOAD_LINKS.GOOGLE_PLAY}}</p>
              </div>
            </a>
          </div>
        </div>
        <div class="col-12 col-lg-6 footer-row">
          <div class="footer-links">
            <h2>LEARN MORE</h2>
            <ul>
              <ng-container *ngIf="!whiteLabelConfig">
                <li>
                  <a [routerLink]="['/about']">About</a>
                </li>
                <li>
                  <a [routerLink]="['/pricing']">Pricing</a>
                </li>
              </ng-container>
              <li>
                <a [routerLink]="['/privacy-policy']">Privacy</a>
              </li>
              <li>
                <a [routerLink]="['/terms-of-service']">Terms & Acceptable Use</a>
              </li>
              <li>
                <a [routerLink]="['/help-faq']">Help Center & FAQ</a>
              </li>
              <ng-container *ngIf="!whiteLabelConfig">
                <li>
                  <a [routerLink]="[ROUTE_PATHS.ADVERTISE_WITH_US]">Advertise with Us</a>
                </li>
                <li>
                  <a [href]="[ROUTE_PATHS.PRESS_ROOM]" target="_self">Press Room</a>
                </li>
                <li>
                  <a [href]="ROUTE_PATHS.RESEARCH" target="_self">Research</a>
                </li>
                <li>
                  <a [href]="ROUTE_PATHS.TOPFANS_PRO" target="_self">TopFan Pro</a>
                </li>
              </ng-container>
            </ul>
          </div>
          <div class="footer-links">
            <h2>FOLLOW US</h2>
            <ul class="share-links">
              <ng-container *ngFor="let footerLinks of SocualMedialLinks">
                <li *ngIf="footerLinks?.name !== 'Google+'">
                  <a [href]="footerLinks.href"
                     target="_blank"
                     rel="noopener noreferrer"
                     [attr.aria-label]="footerLinks.name + ' - opens in new tab'"
                     [attr.title]="footerLinks.name">
                    <span>
                      {{ footerLinks.name }}
                    </span>
                    <em class="{{ footerLinks.icon }}" aria-hidden="true"></em>
                  </a>
                </li>
              </ng-container>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    *ngIf="!hideFooterMenu"
    class="footer-bottom"
    [ngClass]="{ 'custom-footer-bottom': !!backgroundColor }"
    [ngStyle]="{ background: backgroundColor }"
  >
    Copyright © {{ copyRightYear }} TopFan Inc. All rights reserved.
  </div>
</ng-container>
